import React from 'react';
import { useTranslation } from 'react-i18next';

import IWall from 'components/interfaces/IWall';
import SelectInputFieldControlled from 'components/layout/forms/SelectInputFieldControlled';
import translations from 'services/translations/translations';

import getOptions from '../../services/getOptions';
import wallTypes, { BUILDING_WALL } from '../../types/wallTypes';
import getTargetName from '../../../../services/forms/getTargetName';
import getTargetValue from '../../../../services/forms/getTargetValue';

const WallTypeInput = ({
  className,
  handleWall,
  wall,
  disabled,
}: {
  className?: string;
  handleWall: (e: any) => void;
  wall: IWall;
  disabled?: boolean;
}): JSX.Element => {
  const { t } = useTranslation([translations.common]);

  const onWallTypeChange = (change: any) => {
    if (getTargetName(change) === 'wallType') {
      wall.length = getTargetValue(change) === BUILDING_WALL ? 500 : 4000;
    }

    handleWall(change);
  };

  return (
    <SelectInputFieldControlled
      id="walltype"
      label={t(`${translations.common}:Wall Properties.Wall Type`)}
      onChange={onWallTypeChange}
      name="wallType"
      required
      options={getOptions(wallTypes, translations.common, '')}
      value={wall.wallType}
      className={className}
      disabled={disabled}
    />
  );
};

export default WallTypeInput;
